/**
 * Delays invoking `fn` until `wait` ms have passed since the last call.
 *
 * The 2.2 code carried a copy of this on both map.vue and demoalbum.vue, each
 * typing the timer handle as `number` — which is wrong under Node typings and
 * only compiled because the return was never inspected.
 */
export function debounce<TArgs extends unknown[]>(
  fn: (...args: TArgs) => void,
  wait = 50,
): (...args: TArgs) => void {
  let handle: ReturnType<typeof setTimeout> | undefined;

  return (...args: TArgs) => {
    if (handle !== undefined) {
      clearTimeout(handle);
    }

    handle = setTimeout(() => fn(...args), wait);
  };
}
